var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7088 28.9515L31.8374 37.668C29.8112 38.1604 28.5753 40.2002 29.0768 42.2241L40.5798 88.6431C41.0814 90.667 43.1305 91.9086 45.1566 91.4163L81.028 82.6998C83.0542 82.2074 84.2901 80.1676 83.7886 78.1437L72.2856 31.7247C71.784 29.7008 69.7349 28.4592 67.7088 28.9515Z",
    fill: "#CD7900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6816 40.4293L66.4775 32.7031L77.3754 76.6801L45.5794 84.4063L34.6816 40.4293Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2446 54.8648L64.6177 49.9137C65.5178 49.6949 66.4282 50.2465 66.651 51.1457C66.8738 52.0448 66.3247 52.9511 65.4245 53.1698L45.0514 58.1209C44.1512 58.3397 43.2409 57.7881 43.0181 56.889C42.7953 55.9898 43.3444 55.0835 44.2446 54.8648Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6298 48.3467L63.003 43.3956C63.9031 43.1768 64.8134 43.7284 65.0362 44.6276C65.259 45.5267 64.7099 46.433 63.8098 46.6517L43.4366 51.6029C42.5365 51.8216 41.6261 51.2701 41.4033 50.3709C41.1806 49.4717 41.7297 48.5655 42.6298 48.3467Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9111 61.4319L58.1356 58.4611C59.0358 58.2424 59.9462 58.794 60.169 59.6932C60.3918 60.5924 59.8427 61.4987 58.9425 61.7174L46.718 64.6882C45.8178 64.907 44.9074 64.3553 44.6846 63.4561C44.4618 62.5569 45.011 61.6506 45.9111 61.4319Z",
    fill: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.523 27.9631L40.4071 32.1224C38.6065 32.5599 37.5082 34.3726 37.9539 36.1712L38.9626 40.242C39.1854 41.1413 40.0959 41.6929 40.9962 41.4742L61.3723 36.5227C62.2726 36.304 62.8218 35.3976 62.5989 34.4983L61.5902 30.4275C61.1445 28.6289 59.3236 27.5256 57.523 27.9631Z",
    fill: "#D7D6D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1478 22.7095C44.2213 23.4206 42.4362 26.3669 43.1606 29.2902C43.885 32.2135 46.8447 34.0069 49.7712 33.2957C52.6977 32.5846 54.4829 29.6383 53.7585 26.715C53.034 23.7917 50.0744 21.9984 47.1478 22.7095ZM47.955 25.9668C49.0806 25.6933 50.219 26.383 50.4976 27.5074C50.7762 28.6317 50.0896 29.7649 48.964 30.0384C47.8385 30.3119 46.7001 29.6222 46.4215 28.4978C46.1429 27.3735 46.8295 26.2403 47.955 25.9668Z",
    fill: "#D7D6D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2716 71.1044L69.3656 74.9736C69.3821 75.6541 68.8433 76.2167 68.1621 76.2302C67.9678 76.2341 67.7751 76.192 67.5997 76.1075L64.1043 74.4222L60.4494 75.6911C59.8066 75.9142 59.1022 75.5739 58.8759 74.9309C58.8114 74.7475 58.7911 74.5517 58.8167 74.3593L59.3267 70.5253L56.9738 67.4403C56.56 66.8977 56.6635 66.1248 57.2049 65.7139C57.3593 65.5967 57.5395 65.5177 57.7306 65.4833L61.5412 64.799L63.742 61.6235C64.129 61.065 64.8974 60.9277 65.4583 61.3167C65.6183 61.4277 65.7499 61.5747 65.8424 61.7458L67.6875 65.1569L71.4005 66.2794C72.0535 66.4768 72.425 67.1648 72.2302 67.8161C72.1746 68.0019 72.0758 68.1718 71.9419 68.3119L69.2716 71.1044Z",
    fill: "#FFD900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.f198faaee4afc2135635d726ae7fd564.svg";
export { ForwardRef as ReactComponent };